import { connect } from 'react-redux';
import EquipmentDetailPage from './EquipmentDetailPage';

const mapsStateToProps = state => ({
	drawerReducer: state.drawerReducer,
	equipment: state.equipmentDetailPage.basicPageReducer.equipment
});

const mapsDispatchToProps = dispatch => ({

});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(EquipmentDetailPage);
